import React from "react";
import { FaBars } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import { HiX } from 'react-icons/hi'
import './styles.scss'

const routes = [
    { label: 'Home', path: '/' },
    { label: 'About', path: '/about' },
    { label: 'Background', path: '/background' },
    { label: 'Projects', path: '/projects' },
    { label: 'Skills', path: '/skills' },
    { label: 'Contact', path: '/contact' },
]

const Navbar = () => {
    const [toggleIcon, setToggleIcon] = React.useState(false)

    const handleToggleIcon = () => {
        setToggleIcon(!toggleIcon);
    }
    return (
        <div>
            <nav className="navbar">
                <div className="navbar__container">
                    <Link to="https://github.com/ps428" className="navbar__container__logo">
                        &lt;ps428&gt;
                    </Link>
                </div>
                <ul className={`navbar__container__menu ${toggleIcon ? 'active' : ''}`}>
                    {
                        routes.map((route, index) => {
                            return (
                                <Link key={index} to={route.path} onClick={handleToggleIcon}>
                                    <li  className="navbar__container__menu__item">
                                        <div className="navbar__container__menu__item__link">
                                            {route.label}
                                        </div>
                                    </li>
                                </Link>
                            )
                        })
                    }
                </ul>
                <div className="nav-icon" onClick={handleToggleIcon}>
                    {toggleIcon ? <HiX size={30} /> : <FaBars size={30} />}
                </div>
            </nav>
        </div>
    )
}
export default Navbar;